<template>
  <MainLayout>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card width="351" class="ml-auto mr-auto pa-1 pb-5 pt-3 action-card">
          <v-card-text>
            <v-form>
              <UserIdentifierV2
                v-if="stage === 'userIdentifier'"
                :login-hint="loginHint"
              />

              <ChangeSignIn v-else-if="stage === 'accountFound'" />

              <CreateAndLogin v-else-if="stage === 'createAndLogin'" />

              <EnterCode
                v-else-if="stage === 'enterCode' || stage === 'enterTempCode'"
              />

              <EnterPasswordV2 v-show="stage === 'password'" />

              <EnterOtp v-show="stage === 'enterOtp'"></EnterOtp>

              <VerificationMethod
                v-show="stage === 'verificationMethod'"
              ></VerificationMethod>
            </v-form>
          </v-card-text>
        </v-card>
        <div
          v-if="showSignInDifferentAccount"
          class="ml-auto mr-auto mt-8 mb-5 footer"
          :class="{ 'safety-assistant': safetyAssistant }"
        >
          <div class="ml-auto mr-auto footer-link" @click="resetState">
            {{ $t('login.signInAnotherAccount') }}
          </div>
        </div>
        <TermsAndConditions />
      </v-col>
    </v-row>
  </MainLayout>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ChangeSignIn from '@/components/login/ChangeSignIn.vue'
import EnterCode from '@/components/login/EnterCode.vue'
import EnterOtp from '@/components/login/EnterOtp.vue'
import EnterPasswordV2 from '@/components/login/EnterPasswordV2.vue'
import MainLayout from '@/layouts/MainLayout.vue'
import TermsAndConditions from '@/components/termsAndConditions/TermsAndConditions.vue'
import CreateAndLogin from '@/components/account/CreateAndLogin.vue'
import UserIdentifierV2 from '@/components/login/UserIdentifierV2.vue'
import VerificationMethod from '@/components/account/VerificationMethod.vue'
import eventTracker from '@/mixins/eventTracker'
export default {
  metaInfo: {
    title: 'Login',
    titleTemplate: '%s | SALUS',
  },
  name: 'LoginView',
  components: {
    ChangeSignIn,
    CreateAndLogin,
    EnterCode,
    EnterOtp,
    EnterPasswordV2,
    MainLayout,
    TermsAndConditions,
    UserIdentifierV2,
    VerificationMethod,
  },
  mixins: [eventTracker],
  computed: {
    ...mapState({
      stage: 'stage',
      loginHint: 'loginHint',
      user: 'user',
      brandingInfo: 'branding',
    }),
    ...mapGetters({
      qrCode: 'qrCode',
      safetyAssistant: 'safetyAssistant',
    }),
    showSignInDifferentAccount() {
      return this.stage === 'password' || this.stage === 'createAndLogin'
    },
    // Check if branding data is available or if no QR code is present
    brandingReady() {
      return !this.qrCode || this.brandingInfo !== null
    },
  },
  watch: {
    stage: {
      handler() {
        this.trackLoginStage()
      },
    },
    user: {
      handler(newVal) {
        this.setTrackingUser(newVal)
      },
    },
    brandingReady: {
      handler(isReady) {
        if (isReady) {
          this.trackLoginStage()
        }
      },
    },
  },
  async mounted() {
    await this.initSession()
    this.loadPreferredLoginMethod()
    this.setTrackingUser(this.user)
    // track if branding is ready, or watcher will track
    if (this.brandingReady) {
      this.trackLoginStage()
    }
  },
  methods: {
    ...mapActions({
      resetState: 'resetState',
      initSession: 'initSession',
      loadPreferredLoginMethod: 'loadPreferredLoginMethod',
    }),
    trackLoginStage() {
      if (this.stage === 'userIdentifier' && this.brandingReady) {
        this.track('login_page_viewed')
      }
    },
  },
}
</script>
<style scoped lang="sass">
.footer
  display: flex
  justify-content: center
  align-items: center
  width: 351px

  &.safety-assistant
    .footer-link
      color: $primaryBlue !important
</style>
